import { render } from "./UseDocument.vue?vue&type=template&id=504a5ae8&ts=true"
import script from "./UseDocument.vue?vue&type=script&lang=ts"
export * from "./UseDocument.vue?vue&type=script&lang=ts"

import "./UseDocument.vue?vue&type=style&index=0&id=504a5ae8&lang=scss"

import exportComponent from "/Users/zhouyuan/work/project/cargpsweb-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__